/*!
 * This file was created to only avoid "values imports" (constants/enums/classes/etc.) from the `hls.js@1.7.3`
 * to avoid including the whole package in our distribution code.
 *
 * We should still use "type imports" (`import type {}`) from the library!
 *
 * Unit test should cover "copies of the library values" to be sure they are up to date with the library!
 */
import type {Events} from 'hls.js';

/**
 * Partial copy from Hls.js repository
 * @see https://github.com/video-dev/hls.js/blob/v1.7.3/src/types/events.ts#L411
 */
export interface FragLoadedData {
  frag: Fragment;
  networkDetails: unknown;
}

/**
 * Partial copy from Hls.js repository
 * @see https://github.com/video-dev/hls.js/blob/v1.7.3/src/types/loader.ts#L191
 */
export enum PlaylistLevelType {
  AUDIO = 'audio',
  MAIN = 'main',
  SUBTITLE = 'subtitle',
}

/**
 * Partial copy from Hls.js repository
 * @see https://github.com/video-dev/hls.js/blob/v1.7.3/src/loader/fragment.ts#L185
 */
interface Fragment {
  stats: LoaderStats; // `get stats()` in `BaseSegment`
  readonly type: PlaylistLevelType;
}

/**
 * Partial copy from Hls.js repository
 * @see https://github.com/video-dev/hls.js/blob/v1.7.3/src/types/loader.ts#L90
 */
interface LoaderStats {
  total: number;
  loading: {
    end: number;
    first: number;
    start: number;
  };
}

/**
 * Map of Hls Player events that we listen to, each should be type of {@link Events}.
 *
 * Why: This way, we don't need to import string enum {@link Events} from 'hls.js' directly,
 * aka. compile/include it (as value) in our distribution code
 */
export const HLS_PLAYER_EVENT = {
  MEDIA_ATTACHING: 'hlsMediaAttaching' as Events.MEDIA_ATTACHING,
  MEDIA_DETACHING: 'hlsMediaDetaching' as Events.MEDIA_DETACHING,
  MANIFEST_LOADING: 'hlsManifestLoading' as Events.MANIFEST_LOADING,
  AUDIO_TRACK_SWITCHED: 'hlsAudioTrackSwitched' as Events.AUDIO_TRACK_SWITCHED,
  SUBTITLE_TRACK_SWITCH: 'hlsSubtitleTrackSwitch' as Events.SUBTITLE_TRACK_SWITCH,
  DESTROYING: 'hlsDestroying' as Events.DESTROYING,
  ERROR: 'hlsError' as Events.ERROR,
  FRAG_LOADED: 'hlsFragLoaded' as Events.FRAG_LOADED,
} as const;
